import '@fortawesome/fontawesome-svg-core/styles.css';
import './src/css/tailwind.css';
import React from 'react';
import { DemoBookingProvider } from './src/context/DemoBookingContext';

export const wrapRootElement = ({ element }) => (
  <DemoBookingProvider>{element}</DemoBookingProvider>
);
